import { Component, Inject, OnInit } from '@angular/core';
import { TableColumn } from '../../../dto/util/table-column';
import { DocumentosService } from '../../../services/documentos.service';
import { UtilService } from '../../../services/util.service';
import { map } from 'rxjs';
import {
  DocumentoItemDto,
  DocumentosDescargaRequestDto,
} from '../../../dto/expediente/documentos.dto';
import {TranslateService} from "@ngx-translate/core";
import { GlosarioEntidadComponent } from '../../glosario/glosario-entidad/glosario-entidad.component';
import { DescargaArchivosMensajes } from '../../../constants/mensajes-descarga-archivos';

@Component({
  selector: 'app-descarga-documentos',
  templateUrl: './descarga-documentos.component.html',
  styleUrls: ['./descarga-documentos.component.scss'],
})
export class DescargaDocumentosComponent implements OnInit {
  data: any;
  listaDocumentos: DocumentoItemDto[] = [];
  selectedItems: any = [];
  selectedItemsOriginal: any = [];

  columns: TableColumn[] = [];
  pageSize = 5;
  totalPages = 0;
  currentPage = 1;
  // Multilenguaje
  tableText: any = {}
  nombreEntidad = ''
  esArchivoUnico = false;

  constructor(
    @Inject('modalData') private injectedData: any,
    private documentosService: DocumentosService,
    private utilService: UtilService,
    private translate: TranslateService
  ) {
    this.data = injectedData;
    // Multilenguaje
    this.translate.stream('descarga-documentos').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this._initColumns();
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this._getListaDocumentos(this.data.expedienteId, this.data.esInsolvencia || false, this.data.numeroRadicado,this.data.numeroProceso);
    }

    this.utilService.status$.subscribe(status => {
      this.setStatus(status);
    });
  }

  handleSelectedItems(selectedItems: any[]) {
    this.selectedItems = selectedItems;
    this.selectedItemsOriginal = selectedItems;
  }

  downloadDocuments(document?: any): void {
    if(document){
      this.selectedItems = [];
    }
    if(document && this.selectedItems.length == 0){
      this.selectedItems.push(document)
      this.esArchivoUnico = true;
    }else{
      this.esArchivoUnico = false;
    }
    let idDocumento = null;

    if (document) {
      idDocumento = document.documentId ?? (document.id ? +document.id : null);
    }

    const req: DocumentosDescargaRequestDto = {
      ids: idDocumento
        ? [idDocumento]
        : this.selectedItems.map((item: any) =>
            item.documentId ?? parseInt(item.id)
          ),
      idEntidad: parseInt(this.data.entidadId),
      expediente: parseInt(this.data.expedienteId),
      radicado: this.data.radicado,
      esInsolvencia: this.data.esInsolvencia ?? false,
      nombresArchivos: this.selectedItems.map((item: any) =>
        (item.nombre + item.extension.toLowerCase()).trim()
      ),
    };

    this.changueNameEntidad(this.data.entidadId);

    this.utilService.setStatus(DescargaArchivosMensajes.ESTADO_PREPARACION);
    this.documentosService.getDocumentosDescarga(
      req,
      this.data.numeroProceso,
      this.nombreEntidad
    );
  }

  private _getListaDocumentos(expedienteId: number, esInsolvencia: boolean, numeroRadicado?: string,numeroProceso?: string): void {
    this.documentosService
      .getListaDocumentosByExpediente(expedienteId, esInsolvencia, numeroRadicado, numeroProceso)
      .subscribe(response => {
        switch (response.status){
          case 200:
            response.data = response.data.map((item, index) => ({
              ...item,
              id: index.toString()
            }));
            this.listaDocumentos = response.data;
            break;
          case 300:
            this.documentosService.showErrorMessageGeneral(
              DescargaArchivosMensajes.DIGITALIZACION_FALLIDA_TITULO,
              response.message
            );
            break;
          case 301:
            this.documentosService.showWarningMessageGeneral(
              DescargaArchivosMensajes.DIGITALIZACION_PENDIENTE_TITULO,
              response.message
            );
            break;
          default:
            this.documentosService.showErrorMessageGeneral(
              'Error al obtener documentos',
              response.message
            );
            break;
        }
      });
  }

  private _initColumns() {
    this.columns = [
      {
        field: 'nombre',
        title: this.tableText['nombre'],
        type: 'text',
        filterable: false,
        sortable: false,
        accion: item => {
          this.downloadDocuments(item);
        },
      },
      {
        field: 'extension',
        title: this.tableText['tipo-archivo'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'estado',
        title: this.tableText['estado'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
  }

  setStatus(status: string) {
    this.selectedItems.map((item: DocumentoItemDto) => {
      this.listaDocumentos.map(documento => {
        if (item.id == documento.id && item.nombre == documento.nombre) {
          documento.estado = status;
        }
      });
    });
    if (this.esArchivoUnico
      && (status.includes(DescargaArchivosMensajes.ESTADO_FALLIDO)
        || status.includes(DescargaArchivosMensajes.ESTADO_FINALIZADO))) {
      this.selectedItems = this.selectedItemsOriginal;
      this.esArchivoUnico = false;
    }
  }

  changueNameEntidad(idEntidad: number) {
    switch (idEntidad) {
      case 0:
        this.nombreEntidad = '';
        break;
      case 1:
        this.nombreEntidad = 'Superintendencia de Sociedades';
        break;
      case 2:
        this.nombreEntidad = 'SIC';
        break;
      case 3:
        this.nombreEntidad = 'Superintendencia de Salud';
        break;
      case 4:
        this.nombreEntidad = 'Superintendencia Financiera';
        break;
      case 5:
        this.nombreEntidad = 'Dirección Nacional de Derechos de Autor';
        break;
      case 6:
        this.nombreEntidad = 'Dirección General Marítima y Portuaria';
        break;
      case 7:
        this.nombreEntidad = 'Instituto Colombiano Agropecuario';
        break;
      case 8:
        this.nombreEntidad = 'Superintendencia de Sociedades Mercantiles';
    }
  }
}
